import { useEffect } from 'react';
import { IAprioriParameters } from './apriori-interfaces';
import { useAprioriStore } from './dal/apriori-store';
import AprioriParameters from './ui/apriori-parameters';
import AprioriView from './ui/apriori-view';
import { getAprioriJsonStorage } from './dal/apriori-storage';

const initialParameters: IAprioriParameters = {
    "rows": [
        "ABDF",
        "ABCDE",
        "ABCE",
        "ABD"
    ],
    "minSupport": 0.6,
    "minConfidence": 0.8
};

const AprioriHome = () => {

    const params = useAprioriStore(store => store.params);
    const setParams = useAprioriStore(store => store.setParams);

    useEffect(() => {
        const storage = getAprioriJsonStorage();
        if(storage !== '') {
            try{
                const parsed = JSON.parse(storage);
                setParams(parsed);
            }
            catch (ex) {
                setParams(initialParameters);
            }
        }
        else{
            setParams(initialParameters);
        }
    }, [setParams]);

    return(
        <div className="w-full py-2 overflow-auto">

            <div className="w-full mb-4">
                <h1 className="text-2xl px-2 mb-4">Apriori</h1>

                {
                    params &&
                    <div className="flex gap-4 ml-2 items-start">
                        <AprioriParameters />
                        <AprioriView />
                    </div>
                }
            </div>

        </div>
    )
};

export default AprioriHome;
